var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaretUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 11,
    viewBox: "0 0 26 11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-565 -340)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(565 340)",
    fill: "#fdfdfd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 24.63503265380859 10.5 L 1.364967226982117 10.5 L 13 0.6549723148345947 L 24.63503265380859 10.5 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 13 1.309954643249512 L 2.729946136474609 10 L 23.27005386352539 10 L 13 1.309954643249512 M 13 0 L 26 11 L 0 11 L 13 0 Z",
    stroke: "none",
    fill: "#eef3f9"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(565 350)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 24.65263938903809 0.5000037550926208 L 1.338112115859985 0.5000037550926208 L 1.349187731742859 0.4903835952281952 L 24.60956001281738 0.4629232287406921 L 24.65263938903809 0.5000037550926208 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 24.79486083984375 -0.03729629516601562 L 26 1.000003814697266 L 0 1.000003814697266 L 1.162109375 -0.009396255016326904 L 24.79486083984375 -0.03729629516601562 Z",
    stroke: "none",
    fill: "#fdfdfd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretUp);
export default __webpack_public_path__ + "static/media/caret-up.6a9a06fc10c03d2e22668e59fa760f60.svg";
export { ForwardRef as ReactComponent };